import {Comments} from "parts";

export function BookComments() {
  const
    comments = [
      {"date": "Elena S., Public Speaker", "message": "This is not just a book — it's a transformation tool. I practiced for 3 minutes a day and my confidence skyrocketed.", "header": "More Than a Book — A Daily Habit That Transformed My Confidence"},
      {"date": "Marc D., Creative Director", "message": "I used these cues before a big client pitch and landed the deal. The voice and presence drills are gold.", "header": "Voice and Presence Drills That Win Clients"},
      {"date": "Rachel K., Product Lead", "message": "People used to talk over me — now they actually listen. Just a few minutes a day with these cues, and everything changed. I feel seen, heard, and seriously confident.", "header": "From Invisible to Unforgettable"}
    ]

  return (
    <div className={'items center'}>
      <h3 className={'h1'}>✨ Why Readers Love It ✨</h3>
      <Comments list={comments} bg={'var(--bg-70)'}/>
    </div>
  )
}